import $ from "jquery";
import {active} from "./const.js";

$('#js-offcanvasTrigger').on('click', (event) => {
  $(event.currentTarget).toggleClass(active);
  if($(event.currentTarget).hasClass(active)) {
    $('body').css('overflow', 'hidden');
  } else {
    $('body').css('overflow', 'visible');
  }
  $("#js-offcanvas").toggleClass(active);
});
